<template>
  <div class="admin-images">
    <div class="main" v-bind:class="{ dark: darkmode }">
      <!-- <div class="wrap">
        hewwo
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data: () => {
    return {
      socket: null
    }
  },
  computed: {
    darkmode() {
      return this.$store.state.darkmode
    },
  },
  created: function() {
    const local_websocket = true
    const websocket_host = local_websocket ? 'ws://localhost:4000' : 'ws://api.lyninx.com' 
    this.socket = new WebSocket(websocket_host + "/ws")
    this.socket.addEventListener("message", (event) => {
      console.log(event)
    })

    this.socket.addEventListener("close", () => {
      console.warn("websocket connection closed")
    })
  }
}
</script>
